// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"265":"96e5ee5a","346":"96e5ee5a","791":"96e5ee5a","867":"96e5ee5a"}[chunkId] + ".chunk.css";
};